import React, { useState, useEffect } from 'react';

import { Card } from 'react-bootstrap';

import StructureViewer from '../structure_viewer/StructureViewer';
import SequenceViewer from '../sequence_viewer/SequenceViewer';
import NfeTable from '../table/NfeTable';

import PDBeApi from '../../api/PDBeApi';
import CathApi from '../../api/CathApi';
import FunsiteControls from '../structure_viewer/FunsiteControls';

function Layout1(props) {

  const [funfamInfo, setFunfamInfo] = useState(null);
  const [funfamInfoError, setFunfamInfoError] = useState(null);
  const [funfamInfoIsLoading, setFunfamInfoIsLoading] = useState(true);

  const [repDomainInfo, setRepDomainInfo] = useState(null);
  const [repDomainInfoError, setRepDomainInfoError] = useState(null);
  const [repDomainInfoIsLoading, setRepDomainInfoIsLoading] = useState(true);

  const [repGcf, setRepGcf] = useState(null);
  const [repGcfError, setRepGcfError] = useState(null);
  const [repGcfIsLoading, setRepGcfIsLoading] = useState(true);

  const [selectedResidues, setSelectedResidues] = useState([]);
  const [funsiteResidueSets, setFunsiteResidueSets] = useState([]);
  const [repPdbId, setRepPdbId] = useState(null);

  const { funfamId, cathVersion } = props;

  const onLoadStructure = (controller) => {
    const structure = controller.structure
    console.log("onChangeStructure: ", structure);
  }

  useEffect(() => {
    const funfamUrl = `/api/funfam/version/${cathVersion}/id/${funfamId}`;

    const updatePdbInfoFromRepId = (repId) => {

      const chainid = repId.substring(0, 5);

      console.log("updatePdbInfoFromRepId: ", repId);
      PDBeApi.fetchCathBDomainInfo(repId)
        .then((domainInfo) => {
          console.log("setRepDomainInfo: ", domainInfo);
          setRepDomainInfo(domainInfo);
          console.log("setRepPdbId: ", domainInfo.pdb_id);
          setRepPdbId(domainInfo.pdb_id);
          setRepDomainInfoIsLoading(false);
        })
        .catch((error) => {
          const msg = `Failed to get CATH-B domain info for '${repId}': ${error.message}`;
          console.log(msg, error);
          setRepDomainInfoError(msg);
        });

      // CathApi.fetchChainGcf(cathVersion, chainid)
      //   .then((chaingcf) => {
      //     console.log("fetchChainGcf: ", chaingcf);
      //     setRepGcf(chaingcf);
      //     setRepGcfIsLoading(false);
      //   })
      //   .catch((error) => {
      //     const msg = `Failed to get PDB residue mapping for '${chainid}': ${error.message}`;
      //     console.log(msg);
      //     setRepGcfError(msg)
      //   })
    }

    console.log("fetch.funfamUrl:", funfamUrl)
    fetch(funfamUrl)
      .then((res) => {
        if (!res.ok) {
          const msg = 'funfam response not ok'
          console.log(msg, res)
          throw new Error(msg)
        }
        return res.json()
      })
      .then(response => {
        const repId = response.rep_id;
        setFunfamInfo(response);
        console.log("setFunfamInfo", response);
        console.log("updatePdbInfoFromRepId", repId);
        updatePdbInfoFromRepId(repId);
        console.log("setFunfamInfoIsLoading");
        setFunfamInfoIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setFunfamInfoError(error);
      });
  }, [funfamId, cathVersion]);

  let nfe_table;
  let funsite_controls;
  if (funfamInfoError) {
    nfe_table = funsite_controls = `Error: ${funfamInfoError.message}`;
  }
  else if (funfamInfoIsLoading) {
    nfe_table = funsite_controls = 'Loading...';
  }
  else {
    nfe_table = (
      <NfeTable
        funfamId={funfamId}
        cathVersion={cathVersion}
        selectedResidues={selectedResidues}
        onChangeResidues={(residues) => setSelectedResidues(residues)} />
    )
    console.log("funfamInfo", funfamInfo)
    const rep_id = funfamInfo.rep_id
    funsite_controls = (
      <FunsiteControls
        repId={rep_id}
        cathVersion={cathVersion}
        onChangeFunsiteResidueSets={(residueSets) => setFunsiteResidueSets(residueSets)}
      />
    )
  }

  let structure_view;
  if (repDomainInfoError) {
    structure_view = `Error: ${repDomainInfoError.message}`;
  }
  else if (repDomainInfoIsLoading) {
    structure_view = 'Loading...'
  }
  else {
    structure_view = (
      <StructureViewer
        pdbId={repPdbId}
        domainInfo={repDomainInfo}
        selectedResidues={selectedResidues}
        onLoadStructure={onLoadStructure}
        funsiteResidueSets={funsiteResidueSets}
      />
    )
  }

  let sequence_view;
  if (repGcfError) {
    sequence_view = `Error: ${repGcfError}`;
  }
  else if (repGcfIsLoading) {
    sequence_view = 'Loading...'
  }
  else {
    console.log("repGcf", repGcf);
    sequence_view = (
      <SequenceViewer
        chainId={repGcf.chainid}
        chainGcf={repGcf}
        domainInfo={repDomainInfo}
        selectedResidues={selectedResidues}
      />
    )
  }

  const repId = repDomainInfo ? repDomainInfo.domain_id : 'Loading...';
  return (
    <div className="row">
      <div className="col-sm-6">
        <Card>
          <Card.Header>Putative Neo-Functional Events</Card.Header>
          <Card.Body>
            {nfe_table}
          </Card.Body>
        </Card>
      </div>
      <div className="col-sm-6">
        <Card>
          <Card.Header>Representative Domain: {repId}</Card.Header>
          {structure_view}
          <Card.Footer>
            {funsite_controls}
            {sequence_view}
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
}

export default Layout1;